// Notifiche.tsx — v038: l'interruttore delle notifiche (profilo) e la domanda gentile in Home (una volta sola).
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { attivaNotifiche, domandaNotificheFatta, notificheSupportate, permessoDaChiedere, rinnovaNotifiche, segnaDomandaNotifiche, spegniNotifiche, statoNotifiche, type StatoNotifiche } from "../servizi/notifiche.ts";
import { leggiImpostazione, eBooleano } from "../servizi/impostazioni.ts";
import { IMP_APP } from "../costanti.ts";
import { vibra } from "../servizi/nativo.ts";

const accese = () => leggiImpostazione(IMP_APP.pushAttive, true, eBooleano);

export function InterruttoreNotifiche() {
  const { t, i18n } = useTranslation();
  const [stato, setStato] = useState<StatoNotifiche>(statoNotifiche);
  const [occupato, setOccupato] = useState(false);
  if (!accese()) return null;
  return (
    <>
      {/* v043: la spiegazione sopra la casella */}
      <p className="nota" role={stato === "errore" ? "alert" : undefined}>
        {stato === "negate" ? t("notifiche.negate") : stato === "non_supportate" ? t("notifiche.non_supportate") : stato === "errore" ? t("notifiche.errore") : t("notifiche.spiega")}
      </p>
      <label className="interruttore ld-testo-grande-scelta">
        <input
          type="checkbox"
          checked={stato === "attive"}
          disabled={occupato || stato === "non_supportate"}
          onChange={(e) => {
            vibra("scelta");
            setOccupato(true);
            const si = e.target.checked;
            void (si ? attivaNotifiche(i18n.language) : spegniNotifiche().then(() => "spente" as const))
              .then(setStato)
              .catch(() => setStato(statoNotifiche()))
              .finally(() => setOccupato(false));
          }}
        />
        <span>{t("notifiche.attiva")}</span>
      </label>
    </>
  );
}

/** In Home, per chi ha l'account: «Vuoi sapere quando ti sfidano?» una volta; poi si cambia dal profilo. */
export function DomandaNotifiche() {
  const { t, i18n } = useTranslation();
  const [visibile, setVisibile] = useState(() => accese() && notificheSupportate() && statoNotifiche() === "spente" && !domandaNotificheFatta());
  // con le notifiche già accese: si rinnova l'iscrizione (il servizio del telefono può averla cambiata)
  useEffect(() => {
    void rinnovaNotifiche(i18n.language);
  }, [i18n.language]);
  const [occupato, setOccupato] = useState(false);
  const [errore, setErrore] = useState(false);
  if (!visibile) return null;
  const chiudi = () => {
    segnaDomandaNotifiche();
    setVisibile(false);
  };
  // v040: la domanda resta finché il telefono non risponde: chiudere la finestra del permesso senza scegliere
  // (toccando fuori) non la fa sparire; un errore si dice qui.
  const si = () => {
    vibra("medio");
    setOccupato(true);
    setErrore(false);
    void attivaNotifiche(i18n.language)
      .then((s) => {
        if (s === "attive" || s === "negate" || s === "non_supportate") chiudi();
        else if (s === "errore") setErrore(true);
        else if (!permessoDaChiedere()) chiudi();
      })
      .finally(() => setOccupato(false));
  };
  return (
    <section className="scheda-account ld-domanda-notifiche" aria-live="polite">
      <p className="ld-domanda-notifiche-testo">{t("home.notifiche_domanda")}</p>
      <p className="nota" role={errore ? "alert" : undefined}>{errore ? t("notifiche.errore") : t("notifiche.spiega")}</p>
      <div className="azioni-riga">
        <button type="button" className="pulsante pulsante-secondario" onClick={chiudi}>
          {t("home.notifiche_no")}
        </button>
        <button
          type="button"
          className="pulsante pulsante-primario"
          disabled={occupato}
          onClick={si}
        >
          {t("home.notifiche_si")}
        </button>
      </div>
    </section>
  );
}
